import {
  TRAIL_ASSIGN_REQ,
  TRAIL_ASSIGN_REQ_SUCCESS,
  TRAIL_ASSIGN_REQ_ERROR,
  TRAIL_DETAILS_REQ,
  TRAIL_DETAILS_REQ_SUCCESS,
  TRAIL_DETAILS_REQ_ERROR,
  TRAIL_WORK_HISTORY_REQ,
  TRAIL_WORK_HISTORY_REQ_SUCCESS,
  TRAIL_WORK_HISTORY_REQ_ERROR,
  TRAIL_DETAILS_USER_PREF,
  TRAIL_RECOMMENDATION_PROGRESS_REQ
} from './trailsinfo.type'
import { OrderByEnum } from '@/constants/orderby.constants'
import ApiRest from '@/api/api-rest'
import Trail from '@/resources/models/Trail'
import PrivilegedTrail from '@/resources/models/PrivilegedTrail'

const state = {
  trailsAssignmentStatus: '',
  trailDetailsStatus: '',
  trailWorkHistoryStatus: '',
  trailDetails: {},
  trailWorkHistory: {},
  trailDetailViewUserSetting:
    localStorage.getItem('user_view_preferences') &&
    JSON.parse(localStorage.getItem('user_view_preferences'))['trail_details']
      ? JSON.parse(localStorage.getItem('user_view_preferences')).trail_details
      : { orderBy: OrderByEnum.ASC, collapsedView: true }
}

const getters = {
  trailsAssignmentStatus: state => state.trailsAssignmentStatus,
  trailDetailsStatus: state => state.trailDetailsStatus,
  trailDetails: state => state.trailDetails,
  trailWorkHistoryStatus: state => state.trailWorkHistoryStatus,
  trailWorkHistory: state => state.trailWorkHistory,
  trailDetailViewUserSetting: state => state.trailDetailViewUserSetting
}

// Best Practice - updates state
const mutations = {
  [TRAIL_ASSIGN_REQ]: state => {
    state.trailAssignmentStatus = 'inprogress'
  },
  [TRAIL_ASSIGN_REQ_SUCCESS]: state => {
    state.trailsAssignmentStatus = 'saved'
  },
  [TRAIL_ASSIGN_REQ_ERROR]: state => {
    state.trailsAssignmentStatus = 'failed'
  },
  [TRAIL_DETAILS_REQ]: state => {
    state.trailDetailsStatus = 'inprogress'
  },
  [TRAIL_DETAILS_REQ_SUCCESS]: (state, details) => {
    state.trailDetailsStatus = 'saved'
    state.trailDetails = details
  },
  [TRAIL_DETAILS_REQ_ERROR]: state => {
    state.trailDetailsStatus = 'failed'
  },
  [TRAIL_WORK_HISTORY_REQ]: state => {
    state.trailWorkHistoryStatus = 'inprogress'
  },
  [TRAIL_WORK_HISTORY_REQ_SUCCESS]: (state, history) => {
    state.trailWorkHistoryStatus = 'saved'
    state.trailWorkHistory = history
  },
  [TRAIL_WORK_HISTORY_REQ_ERROR]: state => {
    state.trailWorkHistoryStatus = 'failed'
  },
  [TRAIL_DETAILS_USER_PREF]: (state, pref) => {
    state.trailDetailViewUserSetting = pref
    localStorage.setItem('user_view_preferences', JSON.stringify({ trail_details: pref }))
  },
  [TRAIL_RECOMMENDATION_PROGRESS_REQ]: state => {}
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [TRAIL_DETAILS_REQ] (context, trailId) {
    let trailIdEncoded = encodeURIComponent(trailId)
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_DETAILS_REQ)
      ApiRest()
        .get(`/trails/${trailIdEncoded}`)
        // .get('static/json/niloy.agent-10:path-rule-run-trail.json')
        // .get("static/json/prod_0_9_.agent-9:415778047.json")
        .then(({ data }) => {
          // on polling refresh call, update trail
          let viewPref = context.state.trailDetailViewUserSetting
          let rules = context.rootState.rules.allRulesList
          if (data) {
            data.trailIocInfoList.forEach(ioc => {
              if (_.isUndefined(ioc.rule)) {
                ioc.rule = _.find(rules, { id: `${ioc.ruleid}` })
              }
              if (_.isUndefined(ioc.rule)) {
                ioc.rule = _.find(rules, {
                  id: `${ioc.ruleid}`
                })
              }
            })
            if (context.state.trailDetails instanceof Trail && context.state.trailDetails.trailIdHash === trailId) {
              context.state.trailDetails.state = data.state
              context.state.trailDetails.markedIocs = data.markedIocs
              context.state.trailDetails.updateInfluenceeList(
                data.influenceeList,
                context.rootState.trails.trailsinfoRecords.models
              )
              context.state.trailDetails.updateInfluencerList(
                data.influencerList,
                context.rootState.trails.trailsinfoRecords.models
              )
              context.state.trailDetails.updateIoCAttackDetails(
                data.hostList,
                data.lateralMovementEdges,
                data.trailIocInfoList
              )
              context.state.trailDetails.prepareRecommendations(data.trailIocInfoList)
              context.state.trailDetails.updateWorkHistory(data.workHistory)
              context.state.trailDetailsStatus = 'saved'
              resolve(context.state.trailDetails)
            } else {
              let trail = {}
              if (data.riskScore === 0) {
                trail = new PrivilegedTrail(
                  'trailIdHash',
                  _.merge(data, {
                    trailIdHash: trailId,
                    workHistory: data.workHistory
                  })
                )
              } else {
                trail = new Trail(
                  'trailIdHash',
                  _.merge(data, {
                    trailIdHash: trailId,
                    workHistory: data.workHistory
                  })
                )
              }
              trail.updateInfluenceeList(data.influenceeList, context.rootState.trails.trailsinfoRecords.models)
              trail.updateInfluencerList(data.influencerList, context.rootState.trails.trailsinfoRecords.models)
              trail.prepareIoCAttackDetails([], [], [], viewPref.orderBy)
              trail.setCollapsedView(viewPref.collapsedView)
              trail.prepareRecommendations()
              resolve(trail)
            }
          } else {
            resolve({})
          }
        })
        .catch(errMsg => {
          context.commit(TRAIL_DETAILS_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRAIL_DETAILS_REQ_SUCCESS] (context, trailDetails) {
    context.commit(TRAIL_DETAILS_REQ_SUCCESS, trailDetails)
  },
  [TRAIL_ASSIGN_REQ] (context, trail) {
    let trailIdEncoded = encodeURIComponent(trail.trailId)
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_ASSIGN_REQ)
      ApiRest()
        .post(`/trails/${trailIdEncoded}/assign`, {
          assigned_from: trail.assignFrom,
          owner_id: trail.assignTo,
          comments: trail.comments
        })
        .then(({ data }) => {
          context.commit(TRAIL_ASSIGN_REQ_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRAIL_ASSIGN_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRAIL_WORK_HISTORY_REQ] (context, trailId) {
    let trailIdEncoded = encodeURIComponent(trailId)
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_WORK_HISTORY_REQ)
      ApiRest()
        .get(`/trails/${trailIdEncoded}/history`)
        .then(({ data }) => {
          context.commit(TRAIL_WORK_HISTORY_REQ_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRAIL_WORK_HISTORY_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRAIL_DETAILS_USER_PREF] (context, viewPref) {
    context.commit(TRAIL_DETAILS_USER_PREF, viewPref)
  },
  [TRAIL_RECOMMENDATION_PROGRESS_REQ] (context, trailId) {
    let trailIdEncoded = encodeURIComponent(trailId)
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_RECOMMENDATION_PROGRESS_REQ)
      ApiRest()
        .get(`/trails/recommendation-progress/${trailIdEncoded}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trails/traildetails.module.js